import React from 'react'
import classNames from 'classnames'
import styles from './Loader.module.scss'

export type LoaderProps = {
	width?: string
	color?: 'black' | 'white' | 'grey'
	center?: boolean
}
const Loader: React.FC<LoaderProps> = ({ width = '24px', center, color = 'white' }) => {
	const valueClass = classNames(styles.loader__value, styles[color])

	const rootClasses = classNames(styles.wrapper, { [styles.center]: center })
	return (
		<div className={rootClasses} style={{ width }} data-testid="loader">
			<svg className={styles.loader} viewBox="0 0 24 24">
				<circle className={valueClass} cx="12" cy="12" r="10" data-testid="circle" />
			</svg>
		</div>
	)
}

export default Loader
